import { View, Text, Image, StyleSheet } from "@react-pdf/renderer";

import increaseIcon from "assets/img/report-arrow-increase.png";
import decreaseIcon from "assets/img/report-arrow-decrease.png";

import {
    NullableNumber,
    ReportEdgeItem,
    ReportItemType,
} from "types/Reports";
import { REPORT_SENSOR_REGISTRY } from "constant/report";

import {
    getEdgeCountUnit,
    getEdgeUsedFragment,
    getEdgeWithClause,
    getHighestOrLowestDayDisplay,
} from "../report/utils/reportString";
import { formatValueAndUnitBasedOnTypeInReport } from "../report/utils/reportFormat";

const overallEdgeTextStyles = StyleSheet.create({
    container: {
        width: '100%',
        position: 'relative',
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        alignItems: 'center',
        marginTop: 5,
    },
    image: {
        position: 'relative',
        width: 16,
        height: 16,
    },
    value: {
        position: 'relative',
        fontFamily: 'Roboto',
        fontSize: 10,
        fontWeight: 400,
        color: '#333333',
        marginLeft: 3,
    },
    description: {
        position: 'relative',
        fontFamily: 'Roboto',
        fontSize: 10,
        fontWeight: 400,
        color: '#636363',
        marginLeft: 3,
    },
});

type ReportPDFOverallEdgeTextProps = {
    isHighest: boolean;

    itemType: ReportItemType;
    item: ReportEdgeItem;

    unit: string;

    dateFormat: string;
    numberOfItems: NullableNumber;
};

const ReportPDFOverallEdgeText = ({
    isHighest,
    itemType,
    item,
    unit,
    dateFormat,
    numberOfItems,
}: ReportPDFOverallEdgeTextProps) => {
    let itemValueDisplay = formatValueAndUnitBasedOnTypeInReport(itemType, item.value, unit, true);

    const countUnit = getEdgeCountUnit(itemType, numberOfItems);
    const usedFragment = getEdgeUsedFragment(itemType);
    const used = usedFragment ? `${usedFragment} ` : '';

    const iconSource = isHighest ? increaseIcon : decreaseIcon;
    const edgeText = isHighest ? 'highest' : 'lowest';
    const wasOnText = 'was on';
    const withText = getEdgeWithClause(itemType);

    const subject = `The ${edgeText} ${REPORT_SENSOR_REGISTRY[itemType].edgeSubject} ${wasOnText}`;

    let acrossText = '';

    if (numberOfItems === null) {
        itemValueDisplay += '.*';
    } else {
        acrossText = `${used}across ${numberOfItems} ${countUnit}.*`;
    }

    return (
        <View style={overallEdgeTextStyles.container}>
            <Image
                style={overallEdgeTextStyles.image}
                src={iconSource}
            />
            <Text style={overallEdgeTextStyles.description}>
                {subject}
            </Text>
            <Text style={overallEdgeTextStyles.value}>
                {`${getHighestOrLowestDayDisplay(item.dates, dateFormat)},`}
            </Text>
            <Text style={overallEdgeTextStyles.description}>{withText}</Text>
            <Text style={overallEdgeTextStyles.value}>
                {`${itemValueDisplay}`}
            </Text>
            <Text style={overallEdgeTextStyles.description}>
                {acrossText}
            </Text>
        </View>
    );
};

export default ReportPDFOverallEdgeText;
